import React, {
    useState, useCallback, useEffect,
  } from 'react';
  import { 
    Paper, 
    Container, 
    Typography, 
    Button, 
    Badge, 
    Card, 
    CardHeader, 
    IconButton,
    CardContent, } from '@mui/material';
  import MailOutlineIcon from '@mui/icons-material/MailOutline';
  import { useNavigate } from 'react-router-dom';
  import ImageIcon from '@mui/icons-material/Image';
  import { makeStyles } from '@mui/styles';
  import { useTheme } from '@mui/material/styles';
  import useMediaQuery from '@mui/material/useMediaQuery';
  import { useDispatch, useSelector } from 'react-redux';
  import StatusCard from '../common/components/StatusCard';
  import usePersistedState from '../common/util/usePersistedState';
  import ComponentToolbar from '../main/ComponentToolbar';
  import { useAttributePreference } from '../common/util/preferences';
  import {ReactComponent as LocationIcon} from '../resources/images/track2you/Icons_Location-06.svg';
  import useFilter from '../main/useFilter';
  import MainMap from '../main/MainMap';
  
  
  const useStyles = makeStyles((theme) => ({
    root: {
      height: '100%',
      backgroundColor: '#F7FAFF',
    },
    
    toolbar: {
        display: 'flex',
        gap: theme.spacing(1),
        borderBottomLeftRadius: '30px',
        borderBottomRightRadius: '30px',
        paddingTop: theme.spacing(8),
        backgroundColor: '#6179D3',
      },

      mainContainer: {
        display: 'flex',
        gap: theme.spacing(2),
        padding: theme.spacing(3),
      },
    
      mixerDiv: {
        display: 'flex',
        width: '50%',
        justifyContent: 'right',
      },
    
      mixerButton: {
        borderRadius: '10px',
        right:theme.spacing(2),
      },

      mixerIcon: {
        width:'40px',
        height: '40px',
        borderRadius: '10px',
        padding: theme.spacing(0.3),
        fill: theme.palette.secondary.main,
        backgroundColor: theme.palette.primary.main,
      },
    
      leftTitle: {
       width: '50%',
       color: '#777777',
      },

      settingsCard: {
        margin: theme.spacing(3),
        padding: theme.spacing(0),
        borderRadius: '15px',
      },
    
      settingsCardIcon: {
        color: '#6179D3',
        width: '40px',
        height: '40px',
        padding: '0',
      },
    
      settingsCardHeader: {
        padding: theme.spacing(1),
        fontSize: '10pt'
      },
  }));
  
  const MapPage = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const theme = useTheme();
    const user = useSelector((state) => state.session.user);
    const navigate = useNavigate();

    const mapOnSelect = useAttributePreference('mapOnSelect', true);

  const selectedDeviceId = useSelector((state) => state.devices.selectedId);
  const positions = useSelector((state) => state.session.positions);
  const [filteredPositions, setFilteredPositions] = useState([]);
  const selectedPosition = filteredPositions.find((position) => selectedDeviceId && position.deviceId === selectedDeviceId);

  const [filteredDevices, setFilteredDevices] = useState([]);

  const [keyword, setKeyword] = useState('');
  const [filter, setFilter] = usePersistedState('filter', {
    statuses: [],
    groups: [],
  });
  const [filterSort, setFilterSort] = usePersistedState('filterSort', '');
  const [filterMap, setFilterMap] = usePersistedState('filterMap', false);

  const [eventsOpen, setEventsOpen] = useState(false);

    useFilter(keyword, filter, filterSort, filterMap, positions, setFilteredDevices, setFilteredPositions);
  
    const onEventsClick = useCallback(() => setEventsOpen(true), [setEventsOpen]);

    const handleLinks = (event, value) => {
      switch (value) {
        case 'settings':
          navigate('/settings/settingsPage');
          break;
        case 'work':
          navigate('/work/workPage');
          break;
        case 'activities':
          navigate('/activities/activitiesPage');
          break;
        case 'map':
          navigate('/map/mapMainPage');
          break;
        case 'notifications':
          navigate('/notifications/notificationsPage');
          break;
        case 'logout':
          handleLogout;
          break;
        default:
          break;
      }
    };
  
    return (
      <div className={classes.root}>
        <ComponentToolbar />

        <Container className={classes.mainContainer}>
            <Typography className={classes.leftTitle} variant="h6" component="h6">
            Minha localização
            </Typography>

            <div className={classes.mixerDiv}>
                <Button 
                    className={classes.mixerButon} 
                    variant="text">
                    <LocationIcon className={classes.mixerIcon} />
                </Button>
            </div>
        </Container>

        <MainMap
          filteredPositions={filteredPositions}
          selectedPosition={selectedPosition}
          onEventsClick={onEventsClick}
        />
      </div>
    );
  };
  
  export default MapPage;
  